import abstractModel from "../../core/MercatelyModel";

const csrfToken = document.querySelector('[name=csrf-token]').content;

const resource = '/api/v1/mia_platforms';

const model = abstractModel(resource);

export default model;
